export class PaginationInfo {
  PerPage: number;
  PageNumber: number;
  RowsToHold: number;
  TotalRecords: number;
}
